import React, { Component } from 'react';

import TeamMemberHeader from './team-member-header'
import TeamMemberMain from './team-member-main';
import AnimatedWrapper from '../../core/animated-wrapper';
import shareService from '../../../services/share';
import teamMembersService from '../../../services/team-members';
import LoadingIndication from '../../common/loading-indicator';

import './team-member.css';

class TeamMember extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,
      nameToken: props.match.params.name
    };

    shareService.setupPage({
      title: 'Our Team',
      // isTitlePrefixOn: false,
      tags: ['blog', 'webdev']
    });
  }

  componentDidMount() {
    teamMembersService.getByName(this.state.nameToken)
      .then((memberData) => {
        this.setState({
          isLoading: false,
          memberData,
        });

        shareService.setupPage({
          title: `Our Team - ${ memberData.name }`,
          // isTitlePrefixOn: false,
          tags: ['blog', 'webdev']
        });
        
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }
  
  render() {
    if (this.state.isLoading) {
      return <section><LoadingIndication /></section>
    }

    return (
      <section>
        <div className='team-member-page'>
          <TeamMemberHeader { ...this.state.memberData } />
          <TeamMemberMain { ...this.state.memberData } />
        </div>
      </section>
    );
  }
};

const AnimatedTeamMember = AnimatedWrapper(TeamMember);
export default AnimatedTeamMember;